<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y top max-height="345" z-index="15")
    template(#activator="{ on }")
      v-sheet.text-sm.round-lg.clickable.border-menu(flat outlined @click="fetchInstructions")
        v-row.py-1(no-gutters align="center" style="min-height: 38px;")
          v-col.pl-3
            .text-sm(v-if="selectedItem") {{ selectedItem.value }}
            .text-sm(v-else-if="item.productItem.medication.instruction") {{ item.productItem.medication.instruction }}
            .text-sm.neutral400--text(v-else) Instruction
          v-col.shrink.pr-3(v-if="isFetching")
            v-progress-circular.ma-auto(:width="2" :size="15" color="primary" indeterminate)
          v-col.shrink.pr-2(v-else)
            v-icon(size=20 style="margin-top: 2px;") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus @keyup.enter="onAddItem")
        template(v-if="showAddButton")
          .text-xxs.px-4.italic.mb-2 Hit 
            span.font-semibold.danger500--text ENTER 
            | to add instruction
            br
            span.font-semibold '{{ $options.filters.truncate(itemName, 35) }}'
            br
            | or click 
            span.font-semibold.clickable.underline(@click="onAddItem") HERE
        v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      .d-flex.align-center.justify-space-between.px-4.py-3
        .font-semibold.mr-6 Existing instruction
        y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isFetching") 
      div(v-for="item in instructions" @click="onSelectItem(item)")
        .text-sm.font-normal.pa-4.hover-bg.clickable {{ item.value }}
        v-divider
      template(v-if="!instructions.length")
        .px-4.py-3 {{ $t('no_result_match') }}
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isFetching: false,
    show: false,
    itemName: null,
    diagnoses: [],
    toDeleteItem: null,
    isDeleting: false,
    openDeleteConfirmationDialog: false,
    selectedItem: null,
    page: 1,
    pageSize: 10,
    count: 0,
    instructions: [],
    initialized: false
  }),
  watch: {
    show(val) {
      this.$emit('dropdownOpenClosed', val)
    },
    page () {
      this.fetchInstructions()
    },
    itemName () {
      this.searchStart()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showAddButton() {
      if (this.itemName && this.instructions.every(instruction => instruction.value.toLowerCase() !== this.itemName.toLowerCase())) {
        return true
      }
      return false
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    searchStart: debounce(function () {
      this.page = 1
      this.fetchInstructions()
    }, 750),
    onSelectItem (item) {
      this.selectedItem = item
      this.itemName = ''
      this.$set(this.item.productItem.medication, 'instruction', item.value)
      this.$emit('changed', this.item)
      this.$emit('dropdownOpenClosed', false)
    },
    onAddItem () {
      this.$set(this.item.productItem.medication, 'instruction', this.itemName)
      this.$emit('changed', this.item)
      this.$emit('dropdownOpenClosed', false)
      this.itemName = ''
    },
    async fetchInstructions() {
      if (this.show && !this.initialized) {
        this.show = false
      }
      try {
        this.isFetching = true
        let params = { 
          enabled: true,
          page: this.page,
          page_size: this.pageSize,
          company: this.company.id,
          field: 'medication.instruction',
          search: this.itemName || null
        }
        const { data } = await this.$axios.get('/options', { params })
        this.instructions = data.results
        this.count = data.count
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
        this.show = true
        this.initialized = true
      }
    },
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.disabled-item {
  background-color: var(--v-neutral300);
  color: var(--v-neutral500);
}
</style>